import Cookies from "js-cookie";

export type ModalType = "LogIn" | "Register" | false;
export const EVENT_NAME = "EVENT_SHOW_LOGIN_MODAL";
import { ReasonType } from "./models";
import { getBaseDomain as loginBasePath } from "@Utils/Functions";

export const openAuthModal = ({
	withPromise = false,
	defaultModalType = "LogIn",
	email = "",
	isFromCta = false,
	reason = ReasonType.unknown,
}: {
	withPromise?: boolean;
	defaultModalType?: ModalType;
	email?: string;
	isFromCta?: boolean;
	reason?: ReasonType;
}) => {
	if (withPromise) {
		Cookies.remove("user_info", { domain: loginBasePath(), path: "/" });
		Cookies.remove("frontend_token", { domain: loginBasePath(), path: "/" });
		return new Promise((accept, reject) => {
			if (
				typeof window !== "undefined" &&
				typeof window[EVENT_NAME] !== "undefined" &&
				window[EVENT_NAME]
			) {
				window.dispatchEvent(
					new CustomEvent(EVENT_NAME, {
						detail: {
							defaultModalType: defaultModalType,
							accept: accept,
							reject: reject,
							reason,
							email,
							isFromCta,
						},
					})
				);
			} else {
				reject("WINDOW ISNT LISTENING TO " + EVENT_NAME);
			}
		});
	} else {
		window.dispatchEvent(
			new CustomEvent(EVENT_NAME, {
				detail: {
					defaultModalType: defaultModalType,
					accept: () => {},
					reject: () => {},
					reason,
					email,
					isFromCta,
				},
			})
		);
	}
};
